{{#if !notificationSeen}}
<div class="c-notification">
	<i class="fa fa-bullhorn" aria-hidden="true"></i>
	<a href="https://gist.github.com/jimaek/de24cee25048de8bbe3f0d811695cdf7" target="_blank">
		We're looking for a Senior Node.js Engineer to help expand our open-source projects!
	</a>
	<a on-click="@this.set('notificationSeen', true)" aria-label="Close">
		<i class="fa fa-times" aria-hidden="true"></i>
	</a>
</div>
{{/if}}

<script>
	const has = require('../../assets/js/utils/has');
	const notificationKey = 'job-1-notificationSeen';

	component.exports = {
		data () {
			return {
				notificationSeen: true,
			};
		},
		oninit () {
			if (Ractive.isServer) {
				this.set('notificationSeen', true);
			} else {
				if (has.localStorage()) {
					if (localStorage.getItem(notificationKey)) {
						this.set('notificationSeen', true);
					}

					this.observe('notificationSeen', (newValue) => {
						localStorage.setItem(notificationKey, JSON.stringify(newValue));
					}, { init: false });
				}

				// this.observe('notificationSeen', (newValue) => {
				// 	document.body.classList[newValue ? 'remove' : 'add']('c-notification-visible');
				// });
			}
		},
	};
</script>
